var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBAppAudition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2648 0H9.73519C4.35859 0 0 4.35859 0 9.73519V44.2648C0 49.6414 4.35859 54 9.73519 54H44.2648C49.6414 54 54 49.6414 54 44.2648V9.73519C54 4.35859 49.6414 0 44.2648 0Z",
    fill: "#00005B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.335 14.4297H21.2534L30.1338 39.2214H22.8818L21.6602 35.4473H12.373L11.1514 39.2214H4.19531L13.335 14.4297ZM19.7363 29.5637L17.0352 21.2383L14.334 29.5637H19.7363Z",
    fill: "#9999FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1201 31.7839V19.906H37.5957V31.4878C37.5957 33.5601 38.5947 34.4111 40.2598 34.4111C41.0366 34.4111 41.7026 34.374 42.2578 34.1521V19.906H48.7334V37.5933C46.2539 38.8513 43.5899 39.6284 40.2227 39.6284C33.8955 39.6284 31.1201 37.1123 31.1201 31.7839Z",
    fill: "#9999FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBAppAudition);
export default __webpack_public_path__ + "static/media/B_app_Audition.764eefda5d7843c481ce5310ce99ad8d.svg";
export { ForwardRef as ReactComponent };